// Set per environment via REACT_APP_API_URL (.env.development / .env.production,
// or the GitHub Actions repo variable during CI builds).
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:57771/api';

export { API_BASE_URL };
